import { User } from 'Browser/User';
import { Environment } from 'Common/Environment';
import { SiteBasics } from 'Common/SiteBasics';
import { Urls } from 'Common/Urls';
import { ConnectionToServer, IRootProps } from 'Shared/Root';
import {createContext,useContext} from 'solid-js';

interface ISiteProviderProps extends IRootProps {
	children;
	user: User;
	setUser: (user:User) => void;
}

const SiteContext = createContext();

export function SiteProvider(P:ISiteProviderProps)
{
	return (
		<SiteContext.Provider value={P}>
			{P.children}
		</SiteContext.Provider>
	);
}

export function useBuild():Environment
{
	return (useContext(SiteContext) as ISiteProviderProps).build;
}

export function useSite():SiteBasics
{
	return (useContext(SiteContext) as ISiteProviderProps).site;
}

export function useUser():User
{
	return (useContext(SiteContext) as ISiteProviderProps).user;
}

export function useServer():ConnectionToServer
{
	return (useContext(SiteContext) as ISiteProviderProps).server;
}

export function useUrls()
{
	const context = useContext(SiteContext) as ISiteProviderProps;
	return new Urls(context.build,context.site);
}


